import React from 'react';
import { browserHistory } from 'react-router';
import queryString from 'query-string';

import './start-trial.scss';

// end-of-page sign-up prompt for signed-out visitors
export default ({ location }) => {
  const query = queryString.stringify({
    modal: 'register'
  });

  return (
    <div className="cta-section">
      <div className="cta-glow"></div>
      <div className="cta-grid"></div>
      <div className="cta-inner">
        <h2 className="cta-h2">Try <em>Neurochecklists</em> free</h2>
        <p className="cta-sub">7 days of full access to evidence-based, fully referenced neurology checklists.</p>
        <button
          type="button"
          onClick={() => browserHistory.replace(`${location.pathname}?${query}`)}
          className="btn btn-hero-primary start-trial-btn">Start free trial</button>
      </div>
    </div>
  );
};
